import { RespondToActivationRequest } from '../models';

export const dateTimeFormat = 'dd/MM/yyyy HH:mm:ss';
export const notificationDeclinedHeading = 'The following Activation Request has been declined';
export const notificationAcceptedHeading = 'The following Activation Request has been accepted';
export const acknowledgementMessage = 'I acknowledge that I have read this message ';
export const requiredFieldError = 'This field is required.';
export const submitButtonTitle = 'Submit';

export const notification = {
  instrument: 'BM20201212-04-05',
  activatingPortfolio: 'Portfolio-1-Name',
  supplyingBspPortfolio: 'Portfolio-2-Name',
  activatedQuantity: 20,
  confirmedActivationTime: new Date('2020-12-12T04:20:00.000Z'),
  timeRequestWasAccepted: new Date('2020-12-12T04:21:10.000Z'),
  timeRequestWasDeclined: new Date('2020-12-12T04:20:00.000Z'),
  reasonForDeclining: 'A well formulated justification in accordance with the market rules.',
} as RespondToActivationRequest.Notification;

export const notificationLabels = {
  instrument: 'Instrument',
  activatingPortfolio: 'Activating Portfolio',
  supplyingBspPortfolio: 'Supplying BSP Portfolio',
  activatedQuantity: 'Activated Quantity (MW)',
  confirmedActivationTime: 'Confirmed Activation Time',
  timeRequestWasAccepted: 'Time Request was Accepted',
  timeRequestWasDeclined: 'Time Request was Declined',
  reasonForDeclining: 'Reason for Declining the Activation Request',
} as RespondToActivationRequest.NotificationLabels;

export const response = {
  currentInstrument: {
    instrument: 'BM20201212-04-05',
    requestingTsoPortfolio: 'Portfolio-1-Name',
    supplyingBspPortfolio: 'Portfolio-2-Name',
    requestedQuantity: '20',
    defaultFullDispatchTime: new Date('2020-12-12T04:20:00.000Z'),
    confirmedFullDispatchTime: new Date('2020-12-12T04:15:00.000Z'),
    activationRequestAccepted: true,
    reasonForDeclining: '',
    earlyActivationRequested: false,
    requestedFullDispatchTime: new Date('2020-12-12T04:15:00.000Z'),
  } as RespondToActivationRequest.ResponseCurrentInstrument,
  subsequentInstrument: {
    instrument: 'BM20201212-05-06',
    requestingTsoPortfolio: 'Portfolio-1-Name',
    supplyingBspPortfolio: 'Portfolio-2-Name',
    requestedQuantity: '20',
    defaultFullDispatchTime: new Date('2020-12-12T05:00:00.000Z'),
    confirmedFullDispatchTime: new Date('2020-12-12T05:00:00.000Z'),
    activationRequestAccepted: true,
    reasonForDeclining: '',
  } as RespondToActivationRequest.ResponseSubsequentInstrument,
} as RespondToActivationRequest.ActivationRequestResponse;

export const responseLabels = {
  currentInstrument: 'Current Instrument',
  subsequentInstrument: 'Subsequent Instrument',
  requestingTsoPortfolio: 'Requesting TSO Portfolio',
  supplyingBspPortfolio: 'Supplying BSP Portfolio',
  requestedQuantity: 'Requested Quantity (MW)',
  defaultFullDispatchTime: 'Default Full Dispatch Time',
  earlyActivationRequested: 'Early Activation Requested',
  requestedFullDispatchTime: 'Requested Full Dispatch Time',
  confirmedFullDispatchTime: 'Confirmed Full Dispatch Time',
  activationRequestAccepted: 'Activation Request Accepted',
  reasonForDeclining: 'Reason for Declining the Activation Request',
} as RespondToActivationRequest.ResponseLabels;
